{
  "labels": {
    "paste": "Қою",
    "pasteAsPlaintext": "",
    "pasteCharts": "Диаграммаларды қою",
    "selectAll": "Бәрін таңдау",
    "multiSelect": "",
    "moveCanvas": "",
    "cut": "Қию",
    "copy": "Көшіру",
    "copyAsPng": "",
    "copyAsSvg": "",
    "copyText": "",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "",
    "sendToBack": "",
    "bringToFront": "",
    "sendBackward": "",
    "delete": "Жою",
    "copyStyles": "Стильдерді көшіру",
    "pasteStyles": "Стильдерді қою",
    "stroke": "",
    "changeStroke": "",
    "background": "",
    "changeBackground": "",
    "fill": "",
    "strokeWidth": "",
    "strokeStyle": "",
    "strokeStyle_solid": "",
    "strokeStyle_dashed": "",
    "strokeStyle_dotted": "",
    "sloppiness": "",
    "opacity": "",
    "textAlign": "",
    "edges": "",
    "sharp": "",
    "round": "",
    "arrowheads": "Нұсқар ұштары",
    "arrowhead_none": "Жоқ",
    "arrowhead_arrow": "Нұсқар",
    "arrowhead_bar": "Тосқауыл",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "more_options": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "Қаріп өлшемі",
    "fontFamily": "Қаріп тобы",
    "addWatermark": "",
    "handDrawn": "",
    "normal": "Қалыпты",
    "code": "",
    "small": "Кіші",
    "medium": "Орта",
    "large": "Үлкен",
    "veryLarge": "Өте үлкен",
    "solid": "",
    "hachure": "",
    "zigzag": "",
    "crossHatch": "",
    "thin": "",
    "bold": "",
    "left": "Солға",
    "center": "Ортаға",
    "right": "Оңға",
    "extraBold": "",
    "architect": "",
    "artist": "",
    "cartoonist": "",
    "fileTitle": "Файл атауы",
    "colorPicker": "",
    "canvasColors": "",
    "canvasBackground": "",
    "drawingCanvas": "",
    "clearCanvas": "",
    "layers": "",
    "actions": "",
    "language": "Тіл",
    "liveCollaboration": "",
    "duplicateSelection": "Көшірме",
    "untitled": "Атауысыз",
    "name": "",
    "yourName": "",
    "madeWithExcalidraw": "",
    "group": "",
    "ungroup": "",
    "collaborators": "",
    "toggleGrid": "",
    "addToLibrary": "",
    "removeFromLibrary": "",
    "libraryLoadingMessage": "",
    "libraries": "",
    "loadingScene": "",
    "loadScene": "",
    "align": "",
    "alignTop": "",
    "alignBottom": "",
    "alignLeft": "",
    "alignRight": "",
    "centerVertically": "",
    "centerHorizontally": "",
    "distributeHorizontally": "",
    "distributeVertically": "",
    "flipHorizontal": "",
    "flipVertical": "",
    "viewMode": "",
    "share": "",
    "showStroke": "",
    "showBackground": "",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "",
    "personalLib": "",
    "excalidrawLib": "",
    "decreaseFontSize": "",
    "increaseFontSize": "",
    "unbindText": "",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "",
      "editEmbed": "",
      "create": "",
      "label": "",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "",
      "unlock": "",
      "lockAll": "",
      "unlockAll": ""
    },
    "statusPublished": "",
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": "",
    "followUs": "",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "library": {
    "noItems": "",
    "hint_emptyLibrary": "",
    "hint_emptyPrivateLibrary": "",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "",
    "exportJSON": "",
    "exportImage": "",
    "export": "",
    "copyToClipboard": "",
    "copyLink": "",
    "save": "",
    "saveAs": "",
    "load": "",
    "getShareableLink": "",
    "close": "Жабу",
    "selectLanguage": "Тілді таңдау",
    "scrollBackToContent": "",
    "zoomIn": "",
    "zoomOut": "",
    "resetZoom": "",
    "menu": "Mәзір",
    "done": "Дайын",
    "edit": "",
    "undo": "",
    "redo": "",
    "resetLibrary": "",
    "createNewRoom": "",
    "fullScreen": "",
    "darkMode": "",
    "lightMode": "",
    "systemMode": "",
    "zenMode": "",
    "objectsSnapMode": "",
    "exitZenMode": "",
    "cancel": "",
    "saveLibNames": "",
    "clear": "",
    "remove": "",
    "embed": "",
    "publishLibrary": "",
    "submit": "",
    "confirm": "",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "",
    "couldNotCreateShareableLink": "",
    "couldNotCreateShareableLinkTooBig": "",
    "couldNotLoadInvalidFile": "",
    "importBackendFailed": "",
    "cannotExportEmptyCanvas": "",
    "couldNotCopyToClipboard": "",
    "decryptFailed": "",
    "uploadedSecurly": "",
    "loadSceneOverridePrompt": "",
    "collabStopOverridePrompt": "",
    "errorAddingToLibrary": "",
    "errorRemovingFromLibrary": "",
    "confirmAddLibrary": "",
    "imageDoesNotContainScene": "",
    "cannotRestoreFromImage": "",
    "invalidSceneUrl": "",
    "resetLibrary": "",
    "removeItemsFromsLibrary": "",
    "invalidEncryptionKey": "",
    "collabOfflineWarning": "",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "",
    "imageInsertError": "Суретті жүктеу мүмкін болмады. Кейінірек қайталап көріңіз...",
    "fileTooBig": "Файл өте үлкен. Максималды рұқсат етілген көлем {{maxSize}}.",
    "svgImageInsertError": "",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "",
    "importLibraryError": "",
    "saveLibraryError": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "",
    "lasso": "",
    "image": "Суретті қою",
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "Нұсқар",
    "line": "",
    "freedraw": "",
    "text": "Мәтін",
    "library": "",
    "lock": "",
    "penMode": "",
    "link": "",
    "eraser": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "",
    "selectedShapeActions": "",
    "shapes": ""
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "",
    "text": "",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "",
    "canvasTooBig": "",
    "canvasTooBigTip": ""
  },
  "errorSplash": {
    "headingMain": "",
    "clearCanvasMessage": "",
    "clearCanvasCaveat": "",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": ""
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "",
    "button_stopSession": "",
    "desc_inProgressIntro": "",
    "desc_shareLink": "",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": "Қате"
  },
  "exportDialog": {
    "disk_title": "",
    "disk_details": "Сахна деректерін кейін қайта импорттауға болатын файлға экспорттаңыз.",
    "disk_button": "Файлға сақтау",
    "link_title": "Ортақ сілтеме",
    "link_details": "Тек оқуға арналған сілтеме ретінде экспорттау.",
    "link_button": "Сілтемеге экспорттау",
    "excalidrawplus_description": "Сахнаны өзіңіздің Excalidraw+ жұмыс кеңістігінде сақтаңыз.",
    "excalidrawplus_button": "Экспорт",
    "excalidrawplus_exportError": "Қазіргі уақытта Excalidraw+ үшін экспорттау мүмкін емес..."
  },
  "helpDialog": {
    "blog": "Біздің блогты оқу",
    "click": "шерту",
    "deepSelect": "",
    "deepBoxSelect": "",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "Майысқан нұсқар",
    "curvedLine": "Майысқан сызық",
    "documentation": "Құжаттама",
    "doubleClick": "қос шерту",
    "drag": "апару",
    "editor": "Өңдеу",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "Қате таптыңыз ба? Жолдаңыз",
    "howto": "Біздің нұсқаулықтарды орындаңыз",
    "or": "немесе",
    "preventBinding": "Нұсқарды байланыстыруға жол бермеу",
    "tools": "",
    "shortcuts": "Пернетақта пәрмендері",
    "textFinish": "Өңдеуді аяқтау (мәтіндік редактор)",
    "textNewLine": "Жаңа жолға көшу (мәтіндік редактор)",
    "title": "Көмек",
    "view": "Көру",
    "zoomToFit": "Барлық элементтердің көлеміне сәйкес үлкейту",
    "zoomToSelection": "Таңдалғанды үлкейту",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "publishDialog": {
    "title": "",
    "itemName": "",
    "authorName": "",
    "githubUsername": "",
    "twitterUsername": "",
    "libraryName": "",
    "libraryDesc": "",
    "website": "",
    "placeholder": {
      "authorName": "",
      "libraryName": "",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "",
      "website": ""
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "Сіздің сызбаларыңыз өтпелі шифрлеу арқылы шифрланған, сондықтан Excalidraw серверлері оларды ешқашан көрмейді.",
    "link": "Excalidraw қолданатын өтпелі шифрлеу туралы блог жазбасы"
  },
  "stats": {
    "angle": "Бұрыш",
    "shapes": "",
    "height": "Биіктігі",
    "scene": "Сахна",
    "selected": "Таңдалды",
    "storage": "Сақтау көлемі",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "Барлығы",
    "version": "Нұсқа",
    "versionCopy": "Көшіру үшін басыңыз",
    "versionNotAvailable": "Бұл нұсқа қолжетімсіз",
    "width": "Ені"
  },
  "toast": {
    "addedToLibrary": "",
    "copyStyles": "Стильдер көшірілді.",
    "copyToClipboard": "",
    "copyToClipboardAsPng": "",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Файл сақталды.",
    "fileSavedToFilename": "{filename} сақталды",
    "canvas": "",
    "selection": "таңдау",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": "",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "commandPalette": {
    "title": "",
    "shortcuts": {
      "select": "",
      "confirm": "",
      "close": ""
    },
    "recents": "",
    "search": {
      "placeholder": "",
      "noMatch": ""
    },
    "itemNotAvailable": "",
    "shortcutHint": ""
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
